export default (entities) => ({
  getOrders(organisationId) {
    return entities.Order.findAll(organisationId);
  },
  getOrder(id) {
    return entities.Order.find(id);
  },
});
